import { C } from '../constants/colors.js';
import { N } from '../constants/fonts.js';

export function FeedbackButton({onClick}){
  return <button onClick={onClick} style={{position:"absolute",bottom:16,right:16,zIndex:100,padding:"8px 16px",background:C.purple,color:"#fff",border:"none",borderRadius:20,fontFamily:N,fontSize:13,fontWeight:600,cursor:"pointer",boxShadow:"0 4px 12px rgba(114,9,183,0.35)",transition:"transform 0.2s"}} onMouseEnter={e=>e.currentTarget.style.transform="scale(1.05)"} onMouseLeave={e=>e.currentTarget.style.transform="scale(1)"}>💬 Feedback</button>;
}

// ── SIGN IN SCREEN ──────────────────────────────────────
